// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"bc9fb656","344":"3b4afd6d","629":"eab16338","918":"b252d21b"}[chunkId] + ".chunk.css";
};